import { BillingPlanCode } from '@nx-frontend/shared/types/paywall-types';

const OLD_PLANS_ASSOC: Partial<Record<BillingPlanCode, BillingPlanCode>> = {
  'team-yearly': 'team2024-yearly',
  'team-monthly': 'team2024-monthly',
  'business-monthly': 'team2024-monthly',
  'business-yearly': 'team2024-yearly',
  'business2023-monthly': 'business2024-monthly',
  'business2023-yearly': 'business2024-yearly',
};

export function mapToPlanCode(subsriptionType: BillingPlanCode | null) {
  return subsriptionType ? OLD_PLANS_ASSOC[subsriptionType] ?? subsriptionType : null;
}
